import { LogoHeader } from "../../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../../Components/Inicio/NavDesktop";
import { NavMobile } from "../../Components/Inicio/NavMobile";
import ValidateQRComponent from "../../Components/Patrocinadores/ValidateQRComponent"
import { Footer } from "../../Components/Footer/FooterComponent";

export const ValidateQRPage = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <ValidateQRComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    )
}